import { useCallback } from 'react';

import ChatIcon from '@mui/icons-material/AssistantRounded';

import { useCSChatBot } from '@zenbusiness/application-commons-cs-chatbot';
import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';

import { useAccountExperience } from '#client/hooks/useAccountExperience';

function ChatAction() {
  const { formatMessage } = useIntl();
  const { enterprise } = useAccountExperience();
  const { setFirstAutomatedMessageContent, toggle } = useCSChatBot();

  const handleClick = useCallback(() => {
    if (enterprise?.name) {
      setFirstAutomatedMessageContent(
        formatMessage(
          { id: 'dashboard.helpSection.actions.chatAction.firstMessage' },
          { enterpriseName: enterprise.name }
        )
      );
    }

    toggle(true);
  }, [enterprise?.name, formatMessage, setFirstAutomatedMessageContent, toggle]);

  return (
    <Button
      clickstreamProps={{
        elementName: 'help_section_chat_action'
      }}
      fullWidth
      icon={<ChatIcon />}
      onClick={handleClick}
      variant="text"
      sx={{
        justifyContent: 'start'
      }}
    >
      <FormattedMessage id="dashboard.helpSection.actions.chatAction.label" />
    </Button>
  );
}

export default ChatAction;
